export default "__VITE_PUBLIC_ASSET__2684bfa1__"